import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './DocumentStatusWrapper.module.scss';

type DocumentStatusWrapperProps = {
  children: ReactNode;
  headerIcons?: ReactNode;
  headerText?: string;
};

const DocumentStatusWrapper: React.FC<DocumentStatusWrapperProps> = ({ children, headerIcons, headerText }) => {
  const { t } = useTranslation(['documents']);
  return (
    <div className={`tag-ds ${styles.documentStatusWrapper} mt2 shadow-elevation_1x`}>
      <div className={styles.documentStatusWrapper__header}>
        <div>{headerIcons}</div>
        <h5>{t(`statuses.${headerText}`)}</h5>
      </div>
      <div className={styles.documentStatusWrapper__content}>{children}</div>
    </div>
  );
};

export default DocumentStatusWrapper;
